import * as React from 'react';
import { observer } from 'mobx-react';
import { MerchantLogo } from './merchant-logo';
import { ErrorBoundary } from '../../../Shared/components/error-boundary';
import { ErrorInfo } from '../../utils/error-utils';
import { BrandingPackage } from '../../webgiving-generated';
import { classNames } from '../../../Shared/utils/classnames';

import {
	merchantLogo,
	enhancedLogo,
	headerContainer,
	headerBackground,
	merchantName,
	merchantHeader,
	merchantDetailsWrapper,
	enhancedDetailsLanguageWrapper,
	enhancedDetailsWrapper,
	accountAndLanguageHidden,
	salutation,
	salutationDimmed,
	dimmedHeader
} from './header.less';

export interface IHeaderProps {
	welcomeMessage?: React.ReactNode | null;
	className?: string;
	tradingName: string;
	merchantWebsiteUrl: string;
	logoUrl: string;
	brandingPackage: BrandingPackage | null;
	onError: (errorInfo: ErrorInfo, customData?: any) => void;
	transparentBackground?: boolean;
	hasTranslationEnabled?:  boolean;
	languageAndAccountHidden?: boolean;
	supportsBackdrop: boolean; // [FeatureFlagWillMakeThisCodeObsolete(FeatureName.EmbeddedGiving_V1)]
	hasBackdrop?: boolean;
}

@observer
export class MainHeader extends React.Component<IHeaderProps> {
	render() {
		const {
			className,
			onError,
			welcomeMessage,
			tradingName,
			merchantWebsiteUrl,
			brandingPackage,
			logoUrl,
			hasTranslationEnabled = false,
			languageAndAccountHidden = false,
			transparentBackground = false,
			supportsBackdrop,
			hasBackdrop = false,
		} = this.props;

		let merchantLogoUrl = logoUrl;
		let merchantLogoAlt = merchantWebsiteUrl ? `Return to ${tradingName} website` : '';
		let merchantLogoClass = merchantLogo;
		let useBrandingPackageLogo = false;

		let containerClasses = classNames(
			'container',
			headerContainer,
		);
		let headerBackgroundClasses = supportsBackdrop
			? classNames(headerBackground, { 'brand-secondary-bg': !transparentBackground && !hasBackdrop, [dimmedHeader]: !transparentBackground && hasBackdrop })
			: classNames(headerBackground, { 'brand-secondary-bg': !transparentBackground });
		let salutationClasses = supportsBackdrop
			? classNames(salutation, {
					'brand-secondary-alt-bg': !transparentBackground && !hasBackdrop,
					[salutationDimmed]: !transparentBackground && hasBackdrop,
			  })
			: classNames(salutation, { 'brand-secondary-alt-bg': !transparentBackground });

		if (brandingPackage && brandingPackage.EnhancedLogoImageUrl) {
			useBrandingPackageLogo = true;
			merchantLogoUrl = brandingPackage.EnhancedLogoImageUrl;
			merchantLogoClass = enhancedLogo;
			if (! merchantWebsiteUrl) {
				merchantLogoAlt = tradingName;
			}
		}

		const wrapperClasses = classNames({
			[merchantDetailsWrapper]: !useBrandingPackageLogo,
			[enhancedDetailsWrapper]: useBrandingPackageLogo,
			[enhancedDetailsLanguageWrapper]: useBrandingPackageLogo && hasTranslationEnabled,
			[accountAndLanguageHidden]: languageAndAccountHidden
		});

		return (
			<header className={className}>
				{welcomeMessage && <div className={salutationClasses}>{welcomeMessage}</div>}
				<div className={headerBackgroundClasses}>
					<div className={containerClasses}>
						<div className={merchantHeader}>
							<div className={wrapperClasses}>
								<ErrorBoundary onError={onError}>
									<MerchantLogo
										logoUrl={merchantLogoUrl}
										tradingName={tradingName}
										websiteUrl={merchantWebsiteUrl}
										logoClass={merchantLogoClass}
										alt={merchantLogoAlt}
									/>
								</ErrorBoundary>
								{useBrandingPackageLogo ? null :
									<div className={merchantName}>{tradingName}</div>
								}
							</div>
							{this.props.children}
						</div>
					</div>
				</div>
			</header>
		);
	}
}
